// This file is auto-generated. DO NOT EDIT.
// See packages/portal/README.md on how to define and generate routes.
import { generatePath } from 'react-router-dom';

export const ROUTES = {
  dashboard: '/',
  orders: '/orders',
  orderDetails: (params: { orderId: string }) =>
    generatePath('/orders/:orderId', params),
  inventory: '/inventory',
  offers: '/offers',
  offerGroupDetails: (params: { offerGroupPersistentId: string }) =>
    generatePath('/offers/:offerGroupPersistentId', params),
  createOffer: '/offers/create',
  createODDOffer: '/offers/create/odd',
  createPersonalizationOffer: '/offers/create/personalization',
  createUpsellOffer: '/offers/create/upsell',
  createCartOffer: '/offers/create/cart',
  editOffer: (params: { offerGroupPersistentId: string }) =>
    generatePath('/offers/:offerGroupPersistentId/edit', params),
  duplicateOffer: (params: { offerGroupPersistentId: string }) =>
    generatePath('/offers/:offerGroupPersistentId/duplicate', params),
  products: '/products',
  settings: '/settings',
  merchants: '/settings/merchants',
  merchantOverview: (params: { merchantId: string }) =>
    generatePath('/settings/merchants/:merchantId', params),
  merchantViewApiKey: (params: { merchantId: string; apiKeyId: string }) =>
    generatePath('/settings/merchants/:merchantId/keys/:apiKeyId', params),
  merchantCreateApiKey: (params: { merchantId: string }) =>
    generatePath('/settings/merchants/:merchantId/keys/create', params),
  merchantBranding: (params: { merchantId: string }) =>
    generatePath('/settings/merchants/:merchantId/branding', params),
  merchantOrderProcessing: (params: { merchantId: string }) =>
    generatePath('/settings/merchants/:merchantId/order-processing', params),
  b2bOrders: '/b2b-orders',
  b2bOrderDetailsPanel: (params: { orderId: string }) =>
    generatePath('/b2b-orders/:orderId', params),
  createB2BOrder: '/b2b-orders/create',
} as const;
